/** Base URL for the custom project — import from here to avoid typos in `App.jsx` and nav. */
export const CUSTOM_PROJECT_ROUTE = "/custom";
